import { useEffect } from 'react';
import type { ScreenId } from '../protocol/types';

/** Ogni schermo ha il suo manifest, così si può installare ognuno con il suo indirizzo di partenza. */
export const manifestHref = (screen: ScreenId): string => `/manifests/${screen}.webmanifest`;

/** Collega al documento il manifest dello schermo aperto (un solo <link>, aggiornato se cambia schermo). */
export function useManifestLink(screen: ScreenId): void {
  useEffect(() => {
    let link = document.querySelector<HTMLLinkElement>('link[rel="manifest"]');
    if (!link) {
      link = document.createElement('link');
      link.rel = 'manifest';
      document.head.appendChild(link);
    }
    link.setAttribute('href', manifestHref(screen));
  }, [screen]);
}
